import { useEffect } from 'react';

export const usePupeteerSignal = (ready: boolean) => {
  useEffect(() => {
    const el = document.createElement('div');
    el.setAttribute('data-pupeteer', String(ready));
    document.head.appendChild(el);
    return () => {
      el.remove();
    };
  }, [ready]);
};
